
/* Emèlle — Mystery Bag Natalizia automatica */
(() => {
  const config = window.EM?.mysteryBag;
  if (!config?.enabled) return;

  const giftId = Number(config.giftVariantId);
  const minimum = Number(config.minimumCents);
  const eligible = new Set(
    (config.eligibleProductIds || []).map(Number)
  );

  const root = window.Shopify?.routes?.root || "/";
  let running = null;

  // Evita modifiche se la collezione non è stata caricata.
  if (!giftId || !minimum || !eligible.size) {
    console.warn("Mystery Bag: configurazione incompleta");
    return;
  }

  async function request(path, options = {}) {
    const response = await fetch(root + path, {
      credentials: "same-origin",
      ...options
    });

    if (!response.ok) {
      throw new Error("Errore Shopify: " + response.status);
    }

    return response.json();
  }

  async function changeQuantity(key, quantity) {
    return request("cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity })
    });
  }

  async function synchronize() {
    const cart = await request("cart.js");

    const gifts = cart.items.filter(
      item => Number(item.variant_id) === giftId
    );

    const amount = cart.items.reduce((total, item) => {
      if (Number(item.variant_id) === giftId) return total;

      return eligible.has(Number(item.product_id))
        ? total + item.original_line_price
        : total;
    }, 0);

    const qualified = amount >= minimum;
    let changed = false;

    if (!qualified) {
      // Rimuove il regalo se la soglia non è raggiunta.
      for (const gift of gifts) {
        await changeQuantity(gift.key, 0);
        changed = true;
      }
    } else if (gifts.length === 0) {
      // Aggiunge un solo regalo.
      await request("cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [{ id: giftId, quantity: 1 }]
        })
      });
      changed = true;
    } else {
      // Impedisce quantità superiori a un regalo.
      for (let i = gifts.length - 1; i >= 0; i--) {
        if (i > 0 || gifts[i].quantity !== 1) {
          await changeQuantity(
            gifts[i].key,
            i === 0 ? 1 : 0
          );
          changed = true;
        }
      }
    }

    // Aggiorna la pagina del carrello se modificata.
    if (changed && document.querySelector("[data-cart]")) {
      window.location.reload();
    }

    return changed;
  }

  window.EM = window.EM || {};

  window.EM.syncMysteryBag = () => {
    if (running) return running;

    running = synchronize().finally(() => {
      running = null;
    });

    return running;
  };

  window.EM.syncMysteryBag().catch(error => {
    console.error("Mystery Bag:", error);
  });
})();
